import React from "react";
import TextField from "@material-ui/core/TextField";
import { states } from "./states";
import Button from "components/CustomButtons/Button.jsx";
import Grid from "@material-ui/core/Grid";
import { API } from "../config/config";
import axios from "axios";
import { Spiner } from "../Spinner/Spinner";
import { Token } from "../../../redux/action";
import { connect } from "react-redux";

class AppLogin extends React.Component {
  state = {
    loading: false
  };
  submitForm = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    const formData = new FormData();
    formData.append("name", e.target.name.value);
    formData.append("mobile", e.target.mobile.value);
    formData.append("state_id", e.target.state_id.value);
    try {
      const response = await axios.post(
        `${API}/api/MobileRegisters/Insert`,
        formData
      );
      console.log(response);
      if (response.results !== 0) {
        alert("با تشکر ثبت نام با موفقیت انجام شد");
        this.setState({ loading: false });
        this.props.dispatch(Token("app_login"));
      }
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      alert("ارسال با خطا مواجه شد لطفا مجددا سعی نمایید");
    }
  };
  handelCancel = () => {
    this.props.dispatch(Token("app_login"));
  };
  render() {
    const { loading } = this.state;
    return (
      <div className="mobileForm">
        {loading && <Spiner />}
        <p>لطفا ثبت نام نمایید.</p>
        <form onSubmit={this.submitForm}>
          <Grid container className={"search-main-grid"} spacing={5}>
            <Grid item sm={12} className="ex-detail-grid">
              <TextField
                label="نام و نام خانوادگی"
                name="name"
                className="textField"
                margin="normal"
                variant="outlined"
                onInvalid={e =>
                  e.target.setCustomValidity("نام و نام خانوادگی را وارد کنید")
                }
                onInput={e => e.target.setCustomValidity("")}
                required
              />
            </Grid>
            <Grid item sm={12} className="ex-detail-grid">
              <TextField
                label="تلفن همراه"
                className="textField"
                margin="normal"
                variant="outlined"
                type="number"
                name="mobile"
                onInvalid={e =>
                  e.target.setCustomValidity("تلفن همراه را وارد کنید")
                }
                onInput={e => e.target.setCustomValidity("")}
                required
              />
            </Grid>
            <Grid item sm={12} className="ex-detail-grid">
              <TextField
                select
                label="انتخاب استان"
                className={"textField select-states"}
                required
                name="state_id"
                onInvalid={e =>
                  e.target.setCustomValidity("نام استان را وارد نمایید")
                }
                onInput={e => e.target.setCustomValidity("")}
                // value={this.state.selected_state_edit}
                // onChange={this.handleChangestateedit.bind(this)}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: "menu"
                  }
                }}
                margin="normal"
                variant="outlined"
              >
                <option style={{ display: "none" }} />
                {states.map((state, i) => (
                  <option key={i} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item sm={6} md={6}>
              <Button className="search-but" type="submit">
                ارسال
              </Button>
            </Grid>
            {/* <Grid item sm={6} md={6}>
              <Button className="search-but" onClick={this.handelCancel}>
                رد کردن
              </Button>
            </Grid> */}
          </Grid>
        </form>
      </div>
    );
  }
}
export default connect()(AppLogin);
